import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AuthActionPage } from './AuthActionPage';
import { CheckoutReturnPage } from './CheckoutReturnPage';
import { PlansPage } from './PlansPage';
import { SignupPage } from './SignupPage';

type PublicRouteShellProps = {
    dashboardContent: React.ReactNode;
};

// Public routes take precedence without changing the dashboard's existing UI-state controller.
export const PublicRouteShell: React.FC<PublicRouteShellProps> = ({ dashboardContent }) => (
    <BrowserRouter>
        <Routes>
            <Route path='/plans' element={<PlansPage />} />
            <Route path='/plans/embed' element={<PlansPage embedded />} />
            <Route path='/signup' element={<SignupPage />} />
            <Route path='/auth/action' element={<AuthActionPage />} />
            <Route path='/checkout/return' element={<CheckoutReturnPage />} />
            <Route path='/onboarding' element={<Navigate to='/' replace />} />
            <Route path='/organisation/billing' element={dashboardContent} />
            <Route path='/organisation/agreement' element={dashboardContent} />
            <Route path='/' element={dashboardContent} />
            <Route path='*' element={<Navigate to='/' replace />} />
        </Routes>
    </BrowserRouter>
);
